import { createContext } from 'react';
import { IWindowSizeProps } from './types';
import { isBrowser } from '../env';

export const WindowSizeContext = createContext<IWindowSizeProps>({
    windowWidth: isBrowser ? window.innerWidth : 1920
});
